import type { ContactFormRequest, ContactFormResponse, LandingStatsResponse } from '../types';

const baseURL = import.meta.env.VITE_API_URL || '/api/v1';

// Contact Form API
export const contactFormApi = {
  /**
   * Submit contact form data
   * @param data Contact form data
   * @returns Promise with contact form response
   */
  async submitContactForm(data: ContactFormRequest): Promise<ContactFormResponse> {
    try {
      const response = await fetch(`${baseURL}/public/contact/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status} ${response.statusText}`);
      }

      // Server returns only HTTP status code, no JSON response needed
      return {
        success: true,
        message: 'Contact form submitted successfully',
        timestamp: new Date().toISOString()
      };
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  },

  /**
   * Health check for contact form service
   * @returns Promise with health check response
   */
  async healthCheck(): Promise<{ status: string; service: string; timestamp: string }> {
    try {
      const response = await fetch(`${baseURL}/public/contact/health`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error checking contact form service health:', error);
      throw error;
    }
  },
};

// Landing Statistics API
export const landingStatsApi = {
  /**
   * Get landing page statistics
   * @returns Promise with landing statistics response
   */
  async getLandingStats(): Promise<LandingStatsResponse> {
    try {
      const url = `${baseURL}/public/landing/stats`;
      console.log('Making API request to:', url);
      console.log('Base URL:', baseURL);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Response error text:', errorText);
        throw new Error(`Server error: ${response.status} ${response.statusText} - ${errorText}`);
      }

      const data = await response.json();
      console.log('Received data:', data);
      return data;
    } catch (error) {
      console.error('Error fetching landing statistics:', error);
      throw error;
    }
  },
};